import { Injectable, EventEmitter } from "@angular/core";
import { GfxChangeContentEventData } from "./gfx.change.content.event.data";

@Injectable()
export class GfxAppContentService {
    changeContent: EventEmitter<GfxChangeContentEventData> = new EventEmitter<GfxChangeContentEventData>()
} 